import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import FocusTrapper from 'ember-focus-trapper/components/focus-trapper';
import WorkflowReevaluationWarning from 'garaje/components/invites/workflow-reevaluation-warning';
import ButtonGroup from 'garaje/components/ui/button-group';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';

interface WorkflowReevaluationModalSignature {
  Args: {
    onClose: () => void;
    onConfirm: (reason: string | null) => void | Promise<void>;
    isDenied?: boolean;
  };
}

export default class WorkflowReevaluationModal extends Component<WorkflowReevaluationModalSignature> {
  @tracked reason = '';

  @action
  handleConfirm(): void {
    const trimmedReason = this.reason.trim();
    void this.args.onConfirm(trimmedReason ? trimmedReason : null);
  }

  @action
  handleClose(): void {
    this.reason = '';
    this.args.onClose();
  }

  @action
  updateReason(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.reason = target.value;
  }

  <template>
    <ModalDialog
      @clickOutsideToClose={{false}}
      @translucentOverlay={{true}}
      @onClose={{this.handleClose}}
      @targetAttachment="center"
      @containerClass="ember-modal-dialog !max-w-[500px]"
      @overlayClass="ember-modal-overlay--fadeIn"
    >
      <FocusTrapper>
        <div class="p-8" data-test-workflow-reevaluation-modal>
          <WorkflowReevaluationWarning
            @isDenied={{@isDenied}}
            @reason={{this.reason}}
            @onReasonInput={{this.updateReason}}
          />
          <ButtonGroup class="flex justify-end" @reverse={{true}}>
            <button
              type="button"
              class="btn btn--small btn--brand"
              data-test-workflow-reevaluation-confirm
              {{on "click" this.handleConfirm}}
            >
              Save and resubmit for approval
            </button>
            <button
              type="button"
              class="btn btn--small btn--outline"
              data-test-workflow-reevaluation-cancel
              {{on "click" this.handleClose}}
            >
              Cancel
            </button>
          </ButtonGroup>
        </div>
      </FocusTrapper>
    </ModalDialog>
  </template>
}
